import { Grid, Typography } from "@mui/material"
import styles from "../../../../Styles/ComponentStyles/ProfileStyle/AccValueTab.module.scss"
import CustomNumberTextField from "../../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField"
import { useContext, useEffect, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../../../Context/ProfileDetailsContext"

const RetirementIncomeTab = () => {

    const {
        finalData
    } = useContext(ProfileContext) as ProfileContextPayload

    const [riTpAgeMin, setRiTpAgeMin] = useState<number | null>(null);
    const [riTpAgeMax, setRiTpAgeMax] = useState<number | null>(null);
    const [riIULAge, setRiIULAgeMin] = useState<number | null>(null);
    const [riAccAgeMax, setRiIULAgeMax] = useState<number | null>(null);

    const [changeYearTypical, setChangeYearTypical] = useState(finalData?.ageAtRetirement)
    const [changeYearIUL, setChangeYearIUL] = useState(finalData?.ageAtRetirement)

    const [riTypicalAge, setRiTypicalAge] = useState<number[]>([]);
    const [riIULAgeArray, setRiIULAgeArray] = useState<number[]>([]);

    const [flagShowCalculationErrorTp, setCalculationShowErrorTp] = useState(false);

    useEffect(() => {
        if (finalData?.typical_plan?.RI_Age_data && finalData?.iul_plan?.RI_Age_data) {
            const riTypicalAge = Object.keys(finalData.typical_plan.RI_Age_data).map(Number);
            const riIULAge = Object.keys(finalData?.iul_plan?.RI_Age_data).map(Number);

            setRiTypicalAge(riTypicalAge);
            setRiIULAgeArray(riIULAge);

            setRiTpAgeMin(riTypicalAge[0]);
            setRiTpAgeMax(riTypicalAge[riTypicalAge.length - 1]);
            setRiIULAgeMin(riIULAge[0]);
            setRiIULAgeMax(riIULAge[riIULAge.length - 1]);

            setChangeYearTypical(riTypicalAge[0]);
            setChangeYearIUL(riIULAge[0]);
        }
    }, [finalData]);

    useEffect(() => {
        if (changeYearTypical == Number(riTypicalAge[riTypicalAge?.length - 1])) {
            setCalculationShowErrorTp(true)
        } else {
            setCalculationShowErrorTp(false)
        }
    }, [changeYearTypical])

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;

    const formatNumber = (q: any) => {
        if (!q) return q;
        return q.toLocaleString('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: "usd"
        })
    }

    const inputChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(riTpAgeMin) && val <= Number(riTpAgeMax)) {
            setChangeYearTypical(val)
        }
        else {

            if (val >= Number(riTpAgeMax)) {
                setChangeYearTypical(Number(riTpAgeMax))
                val = Number(riTpAgeMax);
            }
            else {
                setChangeYearTypical(Number(riTpAgeMin))
                val = Number(riTpAgeMin);
            }
        }
    }

    const InputChangeYearIUL = (e: any) => {
        let val = parseInt(e.target.value);

        if (val >= Number(riIULAge) && val <= Number(riAccAgeMax)) {
            setChangeYearIUL(val)
        }
        else {

            if (val >= Number(riAccAgeMax))
                setChangeYearIUL(Number(riAccAgeMax))
            else {
                setChangeYearIUL(Number(riIULAge))
            }
        }
    }

    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(riIULAge), Number(riAccAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(riAccAgeMax))
                setChangeYearTypical(Number(riAccAgeMax))
            else {
                setChangeYearTypical(Number(riIULAge))
            }
            return
        }
    }

    const InputBlurChangeIUL = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(riIULAge), Number(riAccAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(riAccAgeMax))
                setChangeYearIUL(Number(riAccAgeMax))
            else {
                setChangeYearIUL(Number(riIULAge))
            }
            return
        }
    }

    return (
        <>
            <Grid container className={styles.accValueTabWrapper}>
                {/* TYPICAL PLAN */}
                <Grid item xs={12} sm={12} md={11} lg={6} xl={6} sx={{ borderRight: "1px solid #E2E8F0" }}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            Typical Plan
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Traditional Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>BASELINE</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                value={changeYearTypical}
                                                onChange={(e) => {
                                                    setChangeYearTypical(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: riTpAgeMin, max: riTpAgeMax } }}
                                                onBlur={inputBlureChangeYear}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        inputChangeYear(e);
                                                }}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container>
                                <Grid item className={styles.outputLabel} xs={10}>Age at Retirement</Grid>
                                <Grid item className={styles.outputValue} xs={2}>{finalData?.ageAtRetirement || 0}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container>
                                <Grid item xs={10} className={styles.outputLabel}>Tax Rate (During Retirement)</Grid>
                                <Grid item xs={2} className={styles.outputValue}>
                                    {finalData?.typical_plan?.tax_rate_during_retirement || 0}%
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={`${styles.fieldContainer} ${styles.withdrawalDetailsSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12} className={styles.sectionTitle}>
                                    Withdrawal Details
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Withdraw from Account</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.annual_pre_tax_income_in_retirement) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Rate of Return (During Retirement)</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.rateOfReturnRetirement || "0"}%</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Contributions to Account</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.total_contribution) || "$0"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.incomeDuringRetirementSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>
                                                Income During Retirement
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Account Value</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.RI_Age_data[changeYearTypical]?.account_value) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Spendable Income</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.RI_Age_data[changeYearTypical]?.annual_sp_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Spendable Income</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.RI_Age_data[changeYearTypical]?.total_annual_sp_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {flagShowCalculationErrorTp &&
                                    <Grid item xs={12} className={styles.typicalValueEmptyTxt}>
                                        Typical plan account value is empty
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* IUL PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            IUL Strategy
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Alternative Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>COMPARISON</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                value={changeYearIUL}
                                                onChange={(e) => {
                                                    setChangeYearIUL(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: riIULAge, max: riAccAgeMax } }}
                                                onBlur={InputBlurChangeIUL}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        InputChangeYearIUL(e);
                                                }}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container>
                                <Grid item className={styles.outputLabel} xs={10}>Age at Retirement</Grid>
                                <Grid item className={styles.outputValue} xs={2}>{finalData?.ageAtRetirement || 0}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container>
                                <Grid item xs={10} className={styles.outputLabel}>Tax Rate (During Retirement)</Grid>
                                <Grid item xs={2} className={styles.outputValue}>0%</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={`${styles.fieldContainer} ${styles.withdrawalDetailsSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12} className={styles.sectionTitle}>
                                    Withdrawal Details
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Withdraw from Account</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.annual_spendable_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Premium Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.total_premiums_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}></Grid>
                                        <Grid item xs={2} className={styles.outputValue}>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.incomeDuringRetirementSection}`}>
                            <Grid container gap={"10px"}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>
                                                Income During Retirement
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Account Value</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.RI_Age_data[changeYearIUL]?.account_value) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Spendable Income</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.RI_Age_data[changeYearIUL]?.annual_sp_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Spendable Income</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.RI_Age_data[changeYearIUL]?.total_annual_sp_income) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Death Benefit</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.iul_plan?.RI_Age_data[changeYearIUL]?.total_death_benefit) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default RetirementIncomeTab